export default __webpack_public_path__ + "static/media/ISWEC-9.99392df2.pdf";